
import {
  DxAsyncRule,
  DxColumn,
  DxDataGrid,
  DxEditing,
  DxEmailRule,
  DxFormat,
  DxItem,
  DxLookup,
  DxPaging,
  DxPatternRule,
  DxRequiredRule,
  DxScrolling,
  DxToolbar,
} from "devextreme-vue/data-grid";
import { DxSelectBox } from "devextreme-vue/select-box";
import { Component, Vue } from "vue-property-decorator";

import { apiUrls } from "@/environment/environment";
import { DxButton } from "devextreme-vue/button";
import IndexationController from "../../shared/services/controllers/indexation/indexationController";

import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { ContentReadyEvent } from "devextreme/ui/select_box";

import { EditorPreparingEvent, InitNewRowEvent, KeyDownEvent, OptionChangedEvent } from "devextreme/ui/data_grid";
import notify from "devextreme/ui/notify";
import { Indexation, Indice } from "../../shared/types/Indexation";

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxLookup,
    DxToolbar,
    DxItem,
    DxButton,
    DxSelectBox,
    DxFormat,
    DxRequiredRule,
    DxEmailRule,
    DxPatternRule,
    DxAsyncRule,
    DxScrolling,
  },
})
export default class IndexGrille extends Vue {
  private controller: IndexationController;

  constructor() {
    super();
    this.controller = new IndexationController(apiUrls.indexation);
  }
  itemsIdices: Indice[] = [];

  selectedIndice: Indice | null = null;
  getSelectedIndice(): Indice | null {
    return this.selectedIndice;
  }

  selectedDisabled = false;
  handlePropertyChange(e: OptionChangedEvent): void {
    if (e.name === "editing") {
      this.selectedDisabled = (this.$refs.dxDataGrid as DxDataGrid)?.instance?.hasEditData() ?? false;
    }
  }

  storeIndexation = new CustomStore({
    key: "id",
    load: async (loadOptions) => {
      let selectedIndex = this.getSelectedIndice();
      if (selectedIndex) {
        const result = await this.controller.indexationStore.getListeIndexations(selectedIndex);
        return {
          data: result.data,
          totalCount: result.itemsCount,
        };
      }
    },
    insert: async (values) => {
      let selectedIndice = this.getSelectedIndice();
      if (selectedIndice) {
        await this.controller.indexationStore
          .addIndexation(values, selectedIndice)
          .then(() => {
            notify(
              {
                message: "Insert success",
                width: 400,
                type: "success",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          })
          .catch((error) => {
            notify(
              {
                message: error.message,
                width: 400,
                type: "error",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          });
      }
    },
    update: async (key, values) => {
      let indexation: Indexation | undefined = undefined;

      // recuperation des data de la grille pour les fusionner avec les modifications
      const gridInstance = (this.$refs.dxDataGrid as DxDataGrid)?.instance;
      if (gridInstance) {
        const rowIndex: number = gridInstance.getRowIndexByKey(key);
        if (rowIndex > -1) {
          indexation = gridInstance.getVisibleRows()[rowIndex].data;
        }
      }
      // fusion des données avec les modifications
      indexation = { ...indexation, ...values };

      if (indexation) {
        await this.controller.indexationStore
          .updateIndexation(key, indexation)
          .then(() => {
            notify(
              {
                message: "Update success",
                width: 400,
                type: "success",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          })
          .catch((error) => {
            notify(
              {
                message: error.message,
                width: 400,
                type: "error",
                displayTime: 3500,
                animation: {
                  show: {
                    type: "fade",
                    duration: 400,
                    from: 0,
                    to: 1,
                  },
                  hide: { type: "fade", duration: 40, to: 0 },
                },
              },
              { position: "top right", direction: "down-push" }
            );
          });
      }
    },
    remove: async (key) => {
      await this.controller.indexationStore
        .removeIndexation(key)
        .then(() => {
          notify(
            {
              message: "Delete success",
              width: 400,
              type: "success",
              displayTime: 3500,
              animation: {
                show: {
                  type: "fade",
                  duration: 400,
                  from: 0,
                  to: 1,
                },
                hide: { type: "fade", duration: 40, to: 0 },
              },
            },
            { position: "top right", direction: "down-push" }
          );
        })
        .catch((error) => {
          notify(
            {
              message: error.message,
              width: 400,
              type: "error",
              displayTime: 3500,
              animation: {
                show: {
                  type: "fade",
                  duration: 400,
                  from: 0,
                  to: 1,
                },
                hide: { type: "fade", duration: 40, to: 0 },
              },
            },
            { position: "top right", direction: "down-push" }
          );
        });
    },
  });

  storeIndice = new CustomStore({
    key: "id",
    load: async (loadOptions) => {
      const result = await this.controller.indexationStore.getListeIndices();
      this.itemsIdices = result.data;
      return {
        data: result.data,
        totalCount: result.itemsCount,
      };
    },
  });

  dataSourceIndexation = new DataSource({
    store: this.storeIndexation,
  });

  dataSourceIndice = new DataSource({
    store: this.storeIndice,
  });

  pattern = /^\d{1,3}.\d{1,3}$/i;
  message = "Format invalide";

  selectIndiceChanged() {
    let dxDataGrid = this.$refs.dxDataGrid as DxDataGrid;
    dxDataGrid?.instance?.refresh();

    let nombreDecimal = this.selectedIndice?.nombreDecimal ? this.selectedIndice?.nombreDecimal : 0;
    let nombreEntier = this.selectedIndice?.nombreEntier ? this.selectedIndice?.nombreEntier : 0;
    this.pattern = new RegExp(`^\\d{1,${nombreEntier}}.\\d{1,${nombreDecimal}}$`, "i");
    this.message = `La valeur doit etre de la forme ${"X".repeat(nombreEntier)}.${"X".repeat(nombreDecimal)} `;
  }

  initialized = false;
  onContentReady(e: ContentReadyEvent) {
    if (!this.initialized) {
      this.initialized = true;
      e.component
        .getDataSource()
        .load()
        .then((res: Indice[]) => {
          e.component.option("value", res[0]);
        });
    }
  }

  onEditorPreparing(e: EditorPreparingEvent): void {
    // Enable la date en edition
    if (e.dataField == "date" && e.parentType == "dataRow") {
      e.editorOptions.disabled = !e.row?.isNewRow;
    }
  }

  asyncDateValidation(params: any) {
    let selectedIndice = this.getSelectedIndice();
    return this.controller.indexationStore.validateNewIndex(params.data, selectedIndice);
  }

  onKeyDown(e: KeyDownEvent) {
    if (e?.event?.ctrlKey && e?.event?.key === "s") {
      e.event.preventDefault(); // Prevents the default behavior
    }
  }

  initNewRow(e: InitNewRowEvent) {
    // initialisation de la date a date du jours lors de l'ajout de ligne
    e.data.date = new Date();
  }
  beforeMount() {
    this.initialized = false;
  }
}
